import React, { useEffect } from 'react';
import { navigate } from 'gatsby';
import { ServiceError as AlienPicture } from '@womcorp/wom-miwom-ui-kit/dist/@theme/assets/svg/pictures';
import {
  ErrorContentStyled as ErrorContent,
  TitleStyled as Title,
  BodyStyled as Body,
  ButtonStyled as Button,
  ServiceErrorStyled as ServiceError,
} from './styles/PanelContentStyled';
import { GoogleTagManager } from '../../../../../helpers';

const InternalError = () => {
  useEffect(() => {
    GoogleTagManager.pushToDataLayer({
      event: 'pagina-virtual',
      page: '/ayuda/problemas-red/modal-reinicio-red/error-serviciointerno',
      pageName: 'Problemas de Red - Reinicio de red - Error Servicio Interno',
    });
  }, []);

  return (
    <ErrorContent>
      <ServiceError>
        <AlienPicture />
      </ServiceError>
      <Body>
        <Title>Error Interno del Servidor</Title>
        Nuestro sistema ha fallado vuelve más tarde
      </Body>
      <Button onClick={() => navigate('/home')}>Ir al inicio</Button>
    </ErrorContent>
  );
};

export default InternalError;
